import facebook from "../assets/icons/facebook.svg";
import twitch from "../assets/icons/twitch.svg";
import twitter from "../assets/icons/twitter.svg";
import youtube from "../assets/icons/youtube-play.svg";
import vk from "../assets/icons/vk.svg";

export { facebook, twitch, twitter, youtube, vk };
